interface EmailStepProps {
  value: string
  onChange: (value: string) => void
}

export function EmailStep({ value, onChange }: EmailStepProps) {
  return (
    <div className="question">
      <h2>Sign up for upcoming classes.</h2>
      <p>Leave your email and we’ll send you the class details.</p>
      <input
        autoFocus
        type="email"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="you@example.com"
      />
    </div>
  )
}
